module.exports = __webpack_public_path__ + "media/images/front/premium_lp/mv_01-ab468736d119cd05bd983e958314dcd0.jpg";